import { Share2 } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Bouton "Partager mon progrès" : génère une carte image (canvas) avec
 * niveau, XP, badge récent → partagée via Web Share API ou copié dans presse-papier.
 */
export default function ShareProgressButton({ user, completedLessons = 0, lastBadge, label = 'Partager mon progrès' }) {

  const generateAndShare = async () => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 1080; canvas.height = 1080;
      const ctx = canvas.getContext('2d');

      // Background gradient
      const grad = ctx.createLinearGradient(0, 0, 1080, 1080);
      grad.addColorStop(0, '#064e3b');
      grad.addColorStop(0.5, '#0f172a');
      grad.addColorStop(1, '#422006');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, 1080, 1080);

      // Decorative dots
      ctx.fillStyle = 'rgba(250,204,21,0.08)';
      for (let i = 0; i < 60; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * 1080, Math.random() * 1080, Math.random() * 5 + 1, 0, Math.PI * 2);
        ctx.fill();
      }

      // Header brand
      ctx.font = 'bold 38px Arial';
      ctx.fillStyle = '#34d399';
      ctx.textAlign = 'center';
      ctx.fillText('JoSmartTech Academy', 540, 140);

      // Trophy emoji as text
      ctx.font = '180px Arial';
      ctx.fillText('🏆', 540, 360);

      // Big XP
      ctx.font = 'bold 140px Arial';
      ctx.fillStyle = '#facc15';
      ctx.fillText(`${user?.xp || 0} XP`, 540, 540);

      // Subline
      ctx.font = 'bold 48px Arial';
      ctx.fillStyle = '#ffffff';
      ctx.fillText(`${user?.name || 'Étudiant'} apprend l'anglais`, 540, 640);

      // Stats line
      ctx.font = '36px Arial';
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.fillText(`🔥 Streak ${user?.streak_days || 0}j  ·  📚 ${completedLessons} leçon${completedLessons > 1 ? 's' : ''}`, 540, 720);

      if (lastBadge) {
        ctx.font = 'bold 36px Arial';
        ctx.fillStyle = '#fbbf24';
        ctx.fillText(`Nouveau badge : ${lastBadge}`, 540, 800);
      }

      // CTA
      ctx.fillStyle = '#34d399';
      ctx.fillRect(190, 880, 700, 100);
      ctx.font = 'bold 42px Arial';
      ctx.fillStyle = '#0a0f1c';
      ctx.fillText('Rejoins-moi sur josmarttech.net/academy', 540, 942);

      // Convert to blob & share
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.95));
      const file = new File([blob], `progres-josmart-${Date.now()}.png`, { type: 'image/png' });

      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Mon progrès — JoSmartTech Academy',
          text: `J'apprends l'anglais sur JoSmartTech Academy ! ${user?.xp || 0} XP gagnés. Rejoins-moi 👉 josmarttech.net/academy`,
        });
      } else {
        // Fallback : download the image
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = file.name; a.click();
        URL.revokeObjectURL(url);
        toast.success('Image téléchargée — partage-la sur tes réseaux !');
      }
    } catch (e) {
      toast.error('Partage impossible : ' + e.message);
    }
  };

  return (
    <button onClick={generateAndShare} data-testid="share-progress"
      className="bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-400 hover:to-amber-400 text-slate-950 font-bold py-2.5 px-4 rounded-xl flex items-center justify-center gap-2 transition shadow-lg shadow-yellow-500/30">
      <Share2 size={16} />{label}
    </button>
  );
}
